import { transduce, map, mergeRight, isEmpty, isNil } from 'ramda';

const toRecord = (fn) => (list = []) => transduce(map(fn), mergeRight, {}, list);
const buildRecord = (list, key) => toRecord((item) => ({
  [item[key]]: item
}))(list);
const buildMap = (list, key) => {
  const map2 = /* @__PURE__ */ new Map();
  for (let index = 0; index < list.length; index++) {
    const element = list[index];
    const value = element[key];
    if (typeof value !== "string" || typeof value !== "number") {
      throw Error(`the ${key} of item only be string or number`);
    }
    map2.set(value, element);
  }
  return map2;
};
const toArray = (v) => Array.isArray(v) ? v : [v];
const takeOne = (v) => Array.isArray(v) ? v[0] : v;
function assertNumber(val, message = "val is not a number") {
  if (val === null || val === void 0 || typeof val !== "number") {
    if (message instanceof Error) {
      throw message;
    }
    throw new Error(message);
  }
}
function assertExists(val, message = "val does not exist") {
  if (val === null || val === void 0) {
    if (message instanceof Error) {
      throw message;
    }
    throw new Error(message);
  }
}
function assertNotExists(val, message = "val exists") {
  if (val !== null && val !== void 0) {
    throw new Error(message);
  }
}
function assertNotEmpty(val, message = "val empty!") {
  if (isEmpty(val)) {
    throw new Error(message);
  }
}
function promisify(cb) {
  if (typeof cb !== "function")
    throw Error("not a function");
  return function promised(options) {
    return new Promise((resolve, reject) => {
      cb.call(this, {
        ...options,
        success: resolve,
        fail: reject
      });
    });
  };
}
function addToIndex(arr, index, val) {
  let prevArr = arr.slice(0, index);
  let nextArr = arr.slice(index);
  return [...prevArr, val, ...nextArr];
}
const delay = (time) => {
  return new Promise((r) => {
    setTimeout(() => {
      r();
    }, time);
  });
};
const generateHtmlAttributes = (json) => {
  return Object.keys(json).map((key) => {
    const value = json[key];
    if (typeof value === "undefined" || value === null) {
      return "";
    }
    return `${key}="${value}"`;
  }).join(" ");
};
function notEmpty(value) {
  return !isNil(value);
}

export { addToIndex, assertExists, assertNotEmpty, assertNotExists, assertNumber, buildMap, buildRecord, delay, generateHtmlAttributes, notEmpty, promisify, takeOne, toArray, toRecord };
